import React, { useContext } from 'react';
import styled from 'styled-components';
import { ReactComponent as StarIcon } from '@ubeya/shared-web/assets/star-gold.svg';
import { ExtraSmall, FlexMiddle, Tooltip } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const RatingValue = styled(ExtraSmall)`
  color: ${({ theme }) => theme.colors.disabled};
  unicode-bidi: plaintext;
`;

const RatingWrapper = styled(FlexMiddle)`
  > svg {
    margin-right: 3px;
    height: 12px;
    width: 12px;
  }
  width: fit-content;
`;

const EmployeeRatingRenderer = ({ rating }) => {
  const { t } = useContext(ConfigContext);

  if (!rating) {
    return <></>;
  }

  return (
    <Tooltip body={t('rating')}>
      <RatingWrapper>
        <StarIcon />
        <RatingValue>{rating}</RatingValue>
      </RatingWrapper>
    </Tooltip>
  );
};

export default EmployeeRatingRenderer;
